import DOMPurify from "dompurify";

export function getEmbedYoutubeUrl(url: string) {
  if (!url) return null;

  const validYoutubeURL = url.includes("youtube") || url.includes("youtu.be");
  if (validYoutubeURL) {
    let videoId = null;

    if (url.includes(".be/")) {
      videoId = url.split(".be/")[1];
    } else if (url.includes("watch?v=")) {
      videoId = url.split("watch?v=")[1];
    } else if (url.includes("shorts")) {
      videoId = url.split("shorts/")[1];
    }

    if (videoId) {
      const iframeUrl = `https://www.youtube.com/embed/${videoId}`;
      return DOMPurify.sanitize(iframeUrl);
    }
  }

  return null;
}
